import React from 'react';
import { IconButton } from '@mui/material';
import { Menu as MenuIcon } from '@mui/icons-material';
import useStores from '../../stores/useStores';

const SidebarToggle = () => {
  const { uiStore } = useStores();
  const handleExpand = () => {
    uiStore.setSidebarExpanded(!uiStore.sidebarExpanded);
  };

  const handleBlur = event => {
    const id = event?.relatedTarget?.id;
    if (['group-name', 'switch-group'].includes(id)) return;
    uiStore.setSidebarExpanded(false);
  };

  return (
    <IconButton
      id="nav-sidebar-toggle"
      className="sidebar--toggle"
      aria-label="Menu"
      onBlur={handleBlur}
      onClick={handleExpand}
      size="large"
    >
      <MenuIcon />
    </IconButton>
  );
};

export default SidebarToggle;
